import { useSyncExternalStore } from "react";

// Whether the flags in hand are the signed-in user's. `loading` is a normal wait
// (flags may still be the anonymous bootstrap's); `unavailable` means LaunchDarkly
// could not be reached, so flag-driven restrictions should not be trusted to apply.
export type LaunchDarklyStatus = "loading" | "ready" | "unavailable";

let status: LaunchDarklyStatus = "loading";
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => status;

export const setLaunchDarklyStatus = (next: LaunchDarklyStatus) => {
  if (next === status) return;
  status = next;
  listeners.forEach((listener) => listener());
};

export const useLaunchDarklyStatus = () => useSyncExternalStore(subscribe, getSnapshot);
